import { NgClass } from '@angular/common'
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatListModule } from '@angular/material/list'
import { MatSidenavModule } from '@angular/material/sidenav'
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { KeycloakService } from 'keycloak-angular'
import packageJson from 'package.json'
import { Observable } from 'rxjs'
import { environment as env } from '../environments/environment'
import { routeAnimations } from './core/core.module'
import { RoleService } from './core/auth/role.service'

@Component({
  selector: 'tcd-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [routeAnimations],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLinkActive,
    RouterLink,
    NgClass,
    RouterOutlet,
    TranslateModule,
    MatSidenavModule,
    FontAwesomeModule,
    MatListModule,
  ],
})
export class AppComponent implements OnInit {
  private readonly translateService = inject(TranslateService)
  private readonly keycloak = inject(KeycloakService)
  private readonly roleService = inject(RoleService)

  public readonly version = packageJson['version']
  public readonly usingMockData = !!env.useMockData

  public readonly isProd = env.production
  public readonly envName = env.envName
  public readonly year = new Date().getFullYear()

  public readonly faBars = faBars
  public readonly faLogout = faSignOutAlt

  languages = ['en']
  navigation = [
    { link: 'about', label: 'tcd.menu.about' },
    { link: '/rules/list', label: 'Overview' },
    { link: 'rules/new-rule', label: 'tcd.features.rule' },
  ]
  navigationSideMenu = [...this.navigation]

  examples = this.roleService.canCreate
    ? [
        { link: 'rules/list', label: 'Overview' },
        { link: 'rules/new-rule', label: 'Create rule' },
      ]
    : [{ link: 'rules/list', label: 'Overview' }]

  isAuthenticated$!: Observable<boolean>
  stickyHeader$!: Observable<boolean>
  language$!: Observable<string>
  theme$!: string

  ngOnInit(): void {
    this.theme$ = 'theme'
    this.translateService.use('en')
  }

  onLogoutClick() {
    localStorage.removeItem('selectedRulePosition')
    sessionStorage.clear()
    this.keycloak.logout()
  }
}
